import { useQuery } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';

/**
 * GET /api/eraf/report-builder/reports/{id} — 리포트 정의 상세
 * queryKey: ['report-builder', 'detail', id]
 */
export function useReportBuilderDetail(id: number | null) {
  return useQuery({
    queryKey: ['report-builder', 'detail', id],
    queryFn: () => reportBuilderApi.get(id!),
    enabled: id !== null,
    staleTime: 60_000,
  });
}
